import { useApiClient } from "@brewardapp/api-client";
import { useStore } from "@breward/store";
import { Button, Loader, TextInput } from "@breward/ui";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const ForgottenPasswordForm = ({ onSuccess }) => {
    const { register, handleSubmit, formState } = useForm();
    const [t] = useTranslation();
    const showNotification = useStore((state) => state.showNotification);

    const api = useApiClient()
    const resetPassword = api.auth.useResetPassword();

    const onSubmit = (values) => {
        resetPassword.mutate(values, {
            onSuccess: () => {
                onSuccess();
                showNotification({
                    type: "success",
                    title: t(
                        "Notifications:ParticipantWeb.passwordResetted.title",
                        "Reset successfully!"
                    ),
                    message: t(
                        "Notifications:ParticipantWeb.passwordResetted.message",
                        "Check your email for further instructions."
                    ),
                });
            },
            onError: (error) => {
                showNotification({
                    type: "error",
                    title: error?.errors?.[0]?.title,
                    message: error?.errors?.[0]?.detail,
                });
            },
        });
    };

    return (
        <div className="">
            {resetPassword?.isLoading ? (
                <Loader />
            ) : (
                <>
                    <TextInput
                        containerClassName="mb-2"
                        autoComplete="email"
                        label={t("global:shared.emailLabel", "Email")}
                        {...register("email", {
                            required: t("global:shared.requiredField", "Field is required"),
                            pattern: {
                                value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                message: t(
                                    "global:shared.invalidEmail",
                                    "Invalid email format"
                                ),
                            },
                        })}
                    />
                    <Button
                        disabled={!formState?.isValid}
                        onClick={() => handleSubmit(onSubmit)()}
                        className="mt-6 text-center text-lg uppercase"
                    >
                        {t("global:shared.resetPassword", "Reset password")}
                    </Button>
                </>
            )}
        </div>
    );
};

export default ForgottenPasswordForm;
